import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { SyntaxHighlighter } from '@/components/ui/syntax-highlighter';
import { ExampleCodeSnippets } from './example-code-snippets';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Examples`}</h2>
    <h3>{`API calls`}</h3>
    <SyntaxHighlighter language="bash" mdxType="SyntaxHighlighter">{ExampleCodeSnippets.apiCalls}</SyntaxHighlighter>
    <br />
    <h3>{`Video content on web`}</h3>
    <p>{`You can use a standard video element available in browsers to play a Clip. Fetch a Clip URL from one of the renditions returned in the videos object and instantiate the `}{`<`}{`video`}{`>`}{` component as follows:`}</p>
    <SyntaxHighlighter language="markup" mdxType="SyntaxHighlighter">{ExampleCodeSnippets.videoContentOnWeb}</SyntaxHighlighter>
    <br />
    <h3>{`Video content on iOS`}</h3>
    <p>{`The iOS SDK repo contains a `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-ios-sdk/tree/main/Clips-Player-Sample-Project"
      }}>{`Clips-specific sample project`}</a>{` which showcases technical solutions playing back Clips in a UICollectionView. While this project features the SDK’s UI for discovering and searching for Clips, the `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-ios-sdk/blob/main/Clips-Player-Sample-Project/clips-example/VideoView.swift"
      }}>{`video components`}</a>{` used for playback in the UICollectionView are unreliant on the SDK and may serve as a useful resource for partners powering their integration with the GIPHY API.`}</p>
    <p>{`Playing back a Clips video asset in your iOS app is easy thanks to Apple’s native APIs.`}</p>
    <p>{`We recommend using the AVFoundation framework, including the AVPlayer, AVPlayerItem, AVPlayerLayer, AVQueuePlayer, and AVPlayerLooper components to support looping video playback.`}</p>
    <p>{`Instantiate a player item with a Clips video asset url like so:`}</p>
    <SyntaxHighlighter language="clike" mdxType="SyntaxHighlighter">{ExampleCodeSnippets.iosInstantiatePlayerItem}</SyntaxHighlighter>
    <br />
    <p>{`Create an AVQueuePlayer and AVPlayerLooper to take care of automatic looping.`}</p>
    <SyntaxHighlighter language="clike" mdxType="SyntaxHighlighter">{ExampleCodeSnippets.avPlayerLooper}</SyntaxHighlighter>
    <br />
    <p>{`Then, all that’s necessary is to set your AVQueuePlayer into the .player property of an AVPlayerLayer. Apple provides a useful code sample for setting up a simple Video Player View here.`}</p>
    <h3>{`Video content on Android`}</h3>
    <p>{`Similar to iOS, we have made source code for our looping video components available in the Android SDK repository. Learn more `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-android-sdk/blob/main/clips.md#videoplayer--videoplayerview"
      }}>{`here`}</a>{` and access the sample code `}<a parentName="p" {...{
        "href": "https://github.com/Giphy/giphy-android-sdk/tree/main/app"
      }}>{`here`}</a>{`.`}</p>
    <p>{`Playing back a Clips video asset in your Android app is best achieved with Google’s ExoPlayer, an application-level media player for Android. We recommend using ExoPlayer over Android MediaPlayer. And here is why:`}</p>
    <p>{`MediaPlayer does not support smooth streaming`}</p>
    <p>{`Exoplayer Supports caching out-of-the-box.`}</p>
    <p>{`MediaPlayer is less customizable as compared to ExoPlayer.`}</p>
    <p>{`The steps to get started with Exoplayer are described here:`}</p>
    <p><a parentName="p" {...{
        "href": "https://exoplayer.dev/hello-world.html"
      }}>{`Hello world! - ExoPlayer`}</a></p>
    <br />
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      